import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Drops from "@/pages/Drops";
import Guatemala from "@/pages/Guatemala";
import SystemDrop from "@/pages/SystemDrop";
import OurStory from "@/pages/OurStory";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import AuthCallback from "@/pages/AuthCallback";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ShopProvider } from "@/context/ShopContext";
import { Toaster } from "sonner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/drops" element={<Drops />} />
        <Route path="/guatemala-drop" element={<Guatemala />} />
        <Route path="/system-drop" element={<SystemDrop />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/:slug" element={<Product />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/account" element={<Account />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <AuthProvider>
          <ShopProvider>
            <CartProvider>
              <AppRouter />
              <Toaster
                position="bottom-center"
                theme="dark"
                toastOptions={{
                  style: {
                    background: "#000",
                    color: "#fff",
                    border: "1px solid #fff",
                    borderRadius: 0,
                  },
                }}
              />
            </CartProvider>
          </ShopProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
